import { Center, Loader, Stack, Text } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

const OidcLoadingFallback = () => {
  const { t } = useTranslate();

  return (
    <Center mih="100vh" px="md">
      <Stack align="center" gap="md">
        <Loader />
        <Text c="dimmed">{t('auth.loading')}</Text>
      </Stack>
    </Center>
  );
};

export default OidcLoadingFallback;
